import React, { useState } from 'react';
import './Profile.css';

const Profile = ({ member }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleCardClick = () => {
    setIsFlipped(!isFlipped);
  };

  return (
    <article className="member-card" onClick={handleCardClick}>
      <div className={`member-card-inner ${isFlipped ? 'is-flipped' : ''}`}>
        <div className="member-card-face member-card-front">
          <img
            src={member.profileImage}
            alt={member.koreanName}
            className="member-photo"
          />
          <div className="member-card-meta">
            <p className="member-nick">{member.nickname}</p>
            <h2 className="member-name">{member.koreanName}</h2>
          </div>
        </div>

        <div className="member-card-face member-card-back">
          <p className="member-back-stamp">{member.nickname}</p>
          <div className="member-back-copy">
            <p className="member-back-nick">{member.nickname}</p>
            <h2 className="member-back-name">{member.koreanName}</h2>
            <p className="member-back-en">{member.englishName}</p>
            <dl className="member-facts">
              <div>
                <dt>생일</dt>
                <dd>{member.birth}</dd>
              </div>
              <div>
                <dt>신체</dt>
                <dd>{member.physical}</dd>
              </div>
              <div>
                <dt>MBTI</dt>
                <dd>{member.mbti}</dd>
              </div>
              {member.bloodType && (
                <div>
                  <dt>혈액형</dt>
                  <dd>{member.bloodType}</dd>
                </div>
              )}
            </dl>
          </div>
        </div>
      </div>
    </article>
  );
};

export default Profile;
